import { Card, CardBody, Col, Row } from "reactstrap";
import VariationAddonsFormContent from "./VariationAddonsFormContent";
import CommonCardFooter from "../../../common/CommonCardFooter";
import { VariationAddonsTitle } from "../../../../../../constants";
import { VariationOfAddonsSubTitle } from "../../../../../../data/formsAndTable/forms/FormControls";
import CommonCardHeader from "../../../../../../coreComponents/CommonCardHeader";

const VariationAddons = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={VariationAddonsTitle} span={VariationOfAddonsSubTitle} />
        <CardBody className="card-wrapper input-radius">
          <Row>
            <Col>
              <VariationAddonsFormContent />
            </Col>
          </Row>
        </CardBody>
        <CommonCardFooter color1="primary" color2="light" />
      </Card>
    </Col>
  );
};
export default VariationAddons;
